import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { AdSDK } from 'tag/ts/tag/model/type/ads/AdSDK';
import { AdSetupDefinition } from 'tag/ts/tag/model/type/ads/AdSetupDefinition';
export class AbstractAdSetupFactory extends AbstractTagClass {
    constructor(argument) {
        super({
            name: 'AbstractAdSetupFactory',
            ...argument
        });
    }
    createDefaultAdSetupInfo() {
        return {
            sdk: {
                module: undefined,
                type: AdSDK.NONE
            },
            setup: {
                type: undefined,
                definition: AdSetupDefinition.NONE
            }
        };
    }
}
